import distanceInWordsToNow from "date-fns/distance_in_words_to_now"
import format from "date-fns/format"
import truncate from "lodash.truncate"

export default {
  // bytes: b => {
  //   b = parseInt(b)
  //   if (isNaN(b)) return NaN
  //   if (b < 1e3) return b + " B"
  //   if (b < 1e6) return (b / 1e3).toFixed(1) + " KB"
  //   if (b < 1e9) return (b / 1e6).toFixed(1) + " MB"

  //   return b.toExponential() + " B"
  // },

  capitalize: text => {
    if (!text) return ""
    return text[0].toUpperCase() + text.substr(1)
  },

  date: format,

  distanceInWordsToNow: (date, addSuffix = true) => {
    return !date ? "" : distanceInWordsToNow(date, { addSuffix })
  },

  // localize: (obj, locale = "en-US") => {
  //   return typeof obj !== "undefined" ? obj.toLocaleString(locale) : ""
  // },

  pluralize: (n, word = "", plural = word + "s") => {
    return n + " " + (n === 1 ? word : plural)
  },

  mtx: v => {
    v = parseFloat(v)
    if (isNaN(v)) return NaN

    const format = v => v.toFixed(1).replace(/\.0/, "")

    if (v === 0) return "0 MTX"
    if (v < 1e-9) return (v * 1e9).toExponential(1) + " nMTX"
    if (v < 1e-6) return format(v * 1e9) + " nMTX"
    if (v < 1e-3) return format(v * 1e6) + " µMTX"
    if (v < 1) return format(v * 1e3) + " mMTX"
    if (v < 1e3) return format(v) + " MTX"
    if (v < 1e6) return format(v / 1e3) + "K MTX"
    if (v < 1e9) return format(v / 1e6) + "M MTX"
    if (v < 1e12) return format(v / 1e9) + "B MTX"

    return v.toExponential(1) + " MTX"
  },

  // https://lodash.com/docs/4.17.11#truncate
  truncate: (str, length = 150, omission = "...") => {
    return truncate(str, {
      length,
      separator: /,? +/,
      omission
    })
  },

  ethAddress: str => {
    return `${str.substr(0, 6)}...${str.substr(-4)}`
  },

  commitHash: str => {
    return str.substr(2, 8)
  }
}
